import {Button} from 'platform/components';

import {useState} from 'react';

import {browserStorageKey, hasMandatoryFieldsValidationOverride} from '@dms/config';

import {useDeveloperSettings} from '../hooks/DeveloperSettingsProvider';
import {getFixedTranslation} from '../utils/getFixedTranslation';

export function MandatoryFieldsValidationToggle() {
  const [
    hasMandatoryFieldsValidationOverrideEnabled,
    setHasMandatoryFieldsValidationOverrideEnabled,
  ] = useState(() => hasMandatoryFieldsValidationOverride());

  const {close} = useDeveloperSettings();

  const handleToggleMandatoryFieldsValidation = () => {
    const hasMandatoryFieldsValidationOverridePersisted = hasMandatoryFieldsValidationOverride();

    if (hasMandatoryFieldsValidationOverridePersisted) {
      localStorage.removeItem(browserStorageKey.DISABLE_MANDATORY_FIELDS_VALIDATION);
      setHasMandatoryFieldsValidationOverrideEnabled(false);
    } else {
      localStorage.setItem(browserStorageKey.DISABLE_MANDATORY_FIELDS_VALIDATION, 'true');
      setHasMandatoryFieldsValidationOverrideEnabled(true);
    }

    window.dispatchEvent(new Event('local-storage'));

    close();
  };

  return (
    <Button
      title={
        hasMandatoryFieldsValidationOverrideEnabled
          ? getFixedTranslation('page.settings.labels.enableMandatoryFieldsValidation')
          : getFixedTranslation('page.settings.labels.disableMandatoryFieldsValidation')
      }
      onClick={handleToggleMandatoryFieldsValidation}
      variant={hasMandatoryFieldsValidationOverrideEnabled ? 'danger' : 'secondary'}
      data-testid="layout-header-devSettings-mandatoryFieldsValidation"
      leftIcon="content/waves"
    />
  );
}
